import { useQuery } from 'react-query'

import { QueryKeys } from '../../../../../enums/queryKeys'
import { Country, getBookkeepers } from '../query-api'

interface UseBookkeepersArgs {
  country?: Country
  searchQuery?: string
  excludeInvitedByOrganizationId?: string
}

export const useBookkeepers = ({ country, searchQuery, excludeInvitedByOrganizationId }: UseBookkeepersArgs = {}) => {
  const { data, isIdle, isLoading } = useQuery(
    [QueryKeys.Bookkeepers, searchQuery, country, excludeInvitedByOrganizationId],
    () => getBookkeepers(country, searchQuery, excludeInvitedByOrganizationId),
  )

  return {
    data: data?.data || [],
    isLoading: isIdle || isLoading,
  }
}
